import { CITIES_STORE_FETCH_ERROR } from '@/entities/location/lib/locationMessages';
import type { ICityRaw, IRegionCity } from '@/entities/location/model/types/location';
import { modifyCities } from '@/entities/location/lib/modifyCities';
import type { PaginationMeta } from '@/shared/model/types/http';
import { isNotEmptyObject } from '@/shared/utils/isNotEmptyObject';
import { logError, normalizeError } from '@/shared/lib/errors';

export const useLocationStore = defineStore('location', () => {
  const { $locationService } = useNuxtApp();

  const cities: Ref<IRegionCity[]> = ref([]);
  const citiesMeta: Ref<PaginationMeta> = ref({});
  const ip: Ref<string | null> = ref(null);
  const isLoadingCities: Ref<boolean> = ref(false);
  const PER_PAGE: number = 60;

  const getCities = async (params = { page: 1, per_page: PER_PAGE }): Promise<void> => {
    if (cities.value.length && isNotEmptyObject(citiesMeta.value)) return;

    isLoadingCities.value = true;
    try {
      const { data, meta } = await $locationService.getAllCities<{
        data: ICityRaw[];
        meta: PaginationMeta;
      }>(params);
      cities.value = modifyCities(data);
      citiesMeta.value = meta;
    } catch (error) {
      logError(normalizeError(error), { action: CITIES_STORE_FETCH_ERROR });
    } finally {
      isLoadingCities.value = false;
    }
  };

  const setCities = (value: IRegionCity[]): void => {
    cities.value = value;
  };

  const setCitiesMeta = (value: PaginationMeta): void => {
    citiesMeta.value = value;
  };

  return {
    cities,
    citiesMeta,
    ip,
    isLoadingCities,
    getCities,
    setCities,
    setCitiesMeta,
  };
});
